import { TextField } from '@mui/material';
import {
  PageWithDrawer,
  NonEditableField,
  getRequiredErrorMessage,
  objectsAreDifferents,
  EditAppBar,
  FieldValidator,
} from '@prismamedia/one-components';
import { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { replaceParams } from '../../../routing/Router';
import { paths } from '../../../routing/Router/paths';
import {
  CreateGoogleGroupMutation,
  GetGoogleGroupQuery_query_googleGroup_GoogleGroup,
  GetGoogleGroupQuery_query_googleGroup_GoogleGroup_role_Role,
} from '../../../__generated__/queries-auth';
import { useGetGoogleGroup } from './getGoogleGroup.auth.graphql';
import { useStyles } from './styles';
import {
  useUpdateGoogleGroup,
  useCreateGoogleGroup,
} from './updateGoogleGroup.auth.graphql';

const emptyRole: GetGoogleGroupQuery_query_googleGroup_GoogleGroup_role_Role = {
  __typename: 'Role',
  id: '',
  slug: '',
};

const emptyItem: GetGoogleGroupQuery_query_googleGroup_GoogleGroup = {
  __typename: 'GoogleGroup',
  id: '',
  groupTitle: '',
  role: emptyRole,
};

const saveMandatoryFields: FieldValidator<
  GetGoogleGroupQuery_query_googleGroup_GoogleGroup
>[] = [
  {
    label: 'Titre',
    validate: ({ groupTitle }) => !!groupTitle,
  },
];

export const UserGroupEditPage: FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const [item, setItem] = useState<
    GetGoogleGroupQuery_query_googleGroup_GoogleGroup | undefined
  >(undefined);
  const { id } = useParams();
  const isCreate = id === 'new';
  const { data, loading, error } = useGetGoogleGroup(id, isCreate);
  const [saveLoading, setSaveLoading] = useState(false);
  const updateItem = useUpdateGoogleGroup();
  const createItem = useCreateGoogleGroup();
  const itemDiff = objectsAreDifferents(
    item,
    isCreate ? emptyItem : data?.googleGroup,
  );
  const requiredFields = getRequiredErrorMessage<
    GetGoogleGroupQuery_query_googleGroup_GoogleGroup
  >(item, saveMandatoryFields);

  useEffect(() => {
    setItem(isCreate ? emptyItem : data?.googleGroup || undefined);
  }, [isCreate, data, setItem]);

  const onSave = async () => {
    if (item) {
      setSaveLoading(true);
      const res = isCreate
        ? await createItem({
            groupTitle: item.groupTitle,
          })
        : await updateItem(item.id, {
            groupTitle: item.groupTitle,
          });
      setSaveLoading(false);
      if (res && isCreate) {
        history.replace(
          replaceParams(paths.USER_GROUP_EDIT, {
            id: (res.data as CreateGoogleGroupMutation).createGoogleGroup.id,
          }),
        );
      }
    }
  };

  return (
    <>
      <EditAppBar
        title={
          isCreate
            ? item?.groupTitle || 'Nouveau groupe utilisateur'
            : data?.googleGroup?.groupTitle || ''
        }
        onNavigateBack={() => history.push(paths.USER_GROUP_LIST)}
        save={{
          disabled: !itemDiff && !isCreate,
          loading: saveLoading,
          onClick: onSave,
          requiredFields,
        }}
      />
      <PageWithDrawer
        loading={loading}
        error={
          error ||
          (!item && !data?.googleGroup
            ? Error("Ce groupe utilisateur n'existe pas")
            : undefined)
        }
        rightDrawer={
          <NonEditableField
            className={classes.field}
            label="Id"
            value={item?.id}
          />
        }
      >
        {item && (
          <>
            <TextField
              className={classes.field}
              label="Titre"
              onChange={({ target: { value } }) => {
                setItem((prev) =>
                  prev ? { ...prev, groupTitle: value } : prev,
                );
              }}
              value={item.groupTitle}
              variant="standard"
            />
          </>
        )}
      </PageWithDrawer>
    </>
  );
};
